module.exports = new __parcel__URL__("navyknit.839c3c2b.jpg").toString();